import React, { useState } from "react";

import { InspectorContextProvider } from "contexts/Inspector";
import ReplaceBrance from "./ReplaceBrance";

const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "ReplaceBrance",
    props: null
  });

  return (
    <InspectorContextProvider>
      <SwitchComponents active={pageProps.active}>
        <ReplaceBrance
          name="ReplaceBrance"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </InspectorContextProvider>
  );
};

export default Index;
